<template>
  <v-dialog
    width="800"
    v-model="opened"
    v-if="task"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    @keydown.esc="$emit('update:opened', false)"
    persistent
    scrollable
  >
    <v-card>
      <v-card-title class="title py-2">
        <v-layout align-start> Task Detail </v-layout>

        <v-spacer />

        <v-btn
          small
          flat
          fab
          class="white error--text text-capitalize"
          @click="$emit('update:opened', false)"
        >
          <v-icon size="24"> clear </v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="py-3 text-xs-left">
        <div class="mb-4">
          <h4 class="label">
            Title
            <v-btn
              small
              flat
              fab
              color="primary"
              class="edit-btn"
              @click="
                editingTitle = true;
                newTitle = task.title;
              "
              v-if="!editingTitle"
            >
              <v-icon small>edit</v-icon>
            </v-btn>
          </h4>

          <div v-if="editingTitle">
            <v-text-field
              v-model="newTitle"
              class="default-input"
              placeholder="Title"
              solo
              hide-details
            />

            <v-layout mt-2>
              <v-btn
                class="small-btn text-none mr-2"
                small
                outline
                color="error"
                @click="editingTitle = false"
              >
                Cancel
              </v-btn>

              <v-btn
                class="small-btn text-none"
                small
                color="primary"
                @click="
                  editingTitle = false;
                  updateTitle(task, newTitle);
                "
              >
                Save
              </v-btn>
            </v-layout>
          </div>

          <span class="task-title" v-else>{{ task.title }}</span>
        </div>

        <div class="mb-4">
          <h4 class="label">
            Description
            <v-btn
              small
              flat
              fab
              color="primary"
              class="edit-btn"
              @click="
                editingDescription = true;
                newDescription = task.description;
              "
            >
              <v-icon small>edit</v-icon>
            </v-btn>
          </h4>

          <div v-if="editingDescription">
            <quill-editor
              v-model="newDescription"
              :options="editorOptions"
              class="description-editor"
            />

            <v-layout mt-2>
              <v-btn
                class="small-btn text-none mr-2"
                small
                outline
                color="error"
                @click="editingDescription = false"
              >
                Cancel
              </v-btn>

              <v-btn
                class="small-btn text-none"
                small
                color="primary"
                @click="
                  editingDescription = false;
                  updateDescription(task, newDescription);
                "
              >
                Save
              </v-btn>
            </v-layout>
          </div>

          <div v-else class="task-description" v-html="task.description" />
        </div>

        <!--
        <div class="mb-4">
          <h4 class="label">
            Tags
            <v-btn
              small
              flat
              fab
              color="primary"
              class="edit-btn"
              @click="editingTags = true;"
              v-if="!editingTags"
            >
              <v-icon small>edit</v-icon>
            </v-btn>
          </h4>

          <div v-if="editingTags">
            <v-combobox
              class="default-input"
              placeholder="Enter tags (press Enter to insert tags)"
              v-model="task.tags"
              multiple
              chips
              small-chips
              solo
              hide-details
            />

            <v-layout mt-2>
              <v-btn
                class="small-btn text-none mr-2"
                small
                outline
                color="error"
                @click="editingTags = false"
              >
                Cancel
              </v-btn>

              <v-btn
                class="small-btn text-none"
                small
                color="primary"
              >
                Save
              </v-btn>
            </v-layout>
          </div>

          <v-layout v-else>
            <v-chip v-for="(tag) in task.tags" small class="tag">
              {{ tag }}
            </v-chip>
          </v-layout>
        </div>
        -->
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/api';
import axios from 'axios';

export default {
  props: {
    opened: {
      type: Boolean,
    },

    task: {
      type: Object,
    },
  },

  data() {
    return {
      editingTitle: false,
      editingDescription: false,
      editingTags: false,

      newTitle: '',
      newDescription: '',

      editorOptions: {
        formats: ['bold', 'italic', 'underline', 'link', 'indent', 'list'],
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{ indent: '-1' }, { indent: '+1' }],
            ['link'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['image'],
          ],
        },
        placeholder: 'Description',
        bounds: '.description-editor',
      },
    };
  },

  methods: {
    async updateTitle(task, title) {
      task.title = title;

      await axios.patch(`/todo_tasks/${task.id}`, {
        ...task,
        title: title,
      });

      this.$emit('todo-updated');
    },

    async updateDescription(task, description) {
      task.description = description;

      await axios.patch(`/todo_tasks/${task.id}`, {
        ...task,
        description: description,
      });

      this.$emit('todo-updated');
    },
  },

  watch: {
    opened(value) {
      if (!value) {
        this.editingTitle = false;
        this.editingDescription = false;
      }
    },
  },
};
</script>

<style lang="postcss" scoped>
.title {
  font-weight: bold;
  letter-spacing: 0px !important;
  border-bottom: 1px solid #ccc;
}

.label {
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 400;
  color: #777;
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.edit-btn {
  width: 32px;
  height: 32px;
  margin: 0;
}

.small-btn {
  margin: 0px;
  min-width: 40px;
}

.task-title {
  font-size: 16px;
}

.task-description {
  font-size: 16px;
  display: flex;
  flex-direction: column;
}
</style>
